import { useLocation } from 'react-router';

const useQuery = (key) => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const value = params[key];
    return value;
};

export default useQuery;
